
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Innovacrystapuneairport() {



    const cardData =
    {
        keyword: 'Innova Crysta Pune Airport Taxi',
        heading: 'Meghana Cab : Innova Crysta Pune Airport Taxi',
        headingDescription: 'Meghana Cab offers Innova Crysta Pune Airport Taxi, providing a premium and seamless airport transfer experience for families, business travelers, and groups. Whether you are arriving at or departing from Pune International Airport, our Innova Crysta vehicles ensure maximum comfort with plush leather seats, spacious interiors, AC climate control, and ample luggage space.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732, Shaniwar Wada was once the grand seat of the Peshwas of the Maratha Empire. Though much of it was destroyed in a fire in 1828, the surviving gates and foundations tell a story of Maratha glory and political intrigue. The Delhi Darwaza (main gate) is especially impressive, and the palace grounds include fountains, courtyards, and the ruins of what was once a seven-storeyed palace. An evening light-and-sound show narrates the fort’s rich history and adds dramatic depth to the visitor experience."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a majestic building with Italian arches and sprawling gardens. Constructed in 1892 to support famine relief efforts, it later became a symbol of India's freedom struggle when Mahatma Gandhi, his wife Kasturba, and his secretary Mahadev Desai were imprisoned here. The palace now houses a museum with rare photos and belongings of the Gandhis, and the serene grounds contain the samadhis of Kasturba Gandhi and Mahadev Desai."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Located about 30 km from Pune, Sinhagad Fort sits atop the Sahyadri Hills at an elevation of 1,317 meters. This ancient hill fortress is most famous for the 1670 Battle of Sinhagad, where Tanaji Malusare fought valiantly for the Marathas. Visitors enjoy panoramic views, rustic food stalls serving bhakri and thecha, and scenic trekking routes. The fort is also dotted with historical points like Tanaji’s memorial and Kalyan Darwaza."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Nestled in Koregaon Park, the Osho Meditation Resort is a globally known center for wellness, meditation, and spiritual healing. Spread across beautifully landscaped gardens and modern zen-style halls, it offers courses in dynamic meditation, therapies, and holistic wellness. It’s not just a spiritual retreat but also a tranquil escape from city life for travelers seeking silence and rejuvenation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Carved out of a single basalt rock in the 8th century, Pataleshwar Cave Temple is a monolithic shrine dedicated to Lord Shiva. Located in the heart of the city near Jangli Maharaj Road, it features intricately carved pillars, a circular Nandi mandap, and a peaceful atmosphere that contrasts sharply with the urban chaos around it. It is a protected monument under the Archaeological Survey of India."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This museum houses over 20,000 rare artifacts collected by Dr. Dinkar Kelkar in memory of his son. From musical instruments and weaponry to sculptures and paintings, it showcases India’s rich cultural heritage in a way that’s both educational and immersive. A recent upgrade added multilingual audio guides, making it an excellent experience for all age groups and tourists."
  },
  {
    "title": "Dagadusheth Halwai Ganapati Temple",
    "description": "One of the most revered temples in Pune, Dagadusheth Halwai Ganapati is known for its massive idol of Lord Ganesha, adorned with gold and silver. The temple is particularly festive during Ganesh Chaturthi, when thousands visit to witness the elaborate decorations, music, and bhajan events. Located in the busy Budhwar Peth area, the temple remains a symbol of devotion and community spirit year-round."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Rising 2,100 feet above sea level, Parvati Hill is Pune’s second-highest point and offers a panoramic view of the city. The hill is crowned by a group of ancient temples built during the Peshwa era, including the Devdeveshwar Temple dedicated to Shiva and Parvati. A 103-step climb leads to this peaceful spiritual site, and a small museum nearby offers insight into Peshwa-era history and culture."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Garden)",
    "description": "Modeled after the famous Okayama Korakuen Garden in Japan, this is one of the largest Japanese-style gardens outside Japan. Spread over 10 acres, it features manicured lawns, natural water flows, elegant bridges, and flower beds that create a peaceful, Zen-like experience. It’s a popular destination for evening walks, photography, and family outings."
  },
  {
    "title": "Rajiv Gandhi Zoological Park (Katraj Zoo)",
    "description": "Spread across 130 acres, this modern zoological park houses a snake park, zoo, and a rescue center for injured animals. It is home to a wide variety of fauna including leopards, elephants, crocodiles, and Indian cobras. It’s a great educational destination for children and families, with ample greenery and shaded pathways for a relaxed experience."
  }
],

 "services": [
    {
      "name": "Innova Crysta Taxi Pune Airport",
      "description": "Book a reliable Innova Crysta taxi for hassle-free travel to or from Pune Airport. Our airport transfer service is tailored for comfort and punctuality, with professional drivers and clean, spacious vehicles perfect for handling luggage and ensuring a smooth experience whether you're arriving or departing."
    },
    {
      "name": "Pune Airport Innova Crysta Cab Booking",
      "description": "Schedule your Pune Airport pickup or drop with ease using our Innova Crysta cab booking service. Ideal for solo travelers, families, and business guests, we ensure timely arrivals, flight monitoring, and a welcoming chauffeur ready to assist you with luggage and a seamless ride."
    },
    {
      "name": "Chauffeur Driven Innova Crysta Pune Airport",
      "description": "Travel in style with our chauffeur-driven Innova Crysta service to or from Pune Airport. Our trained, courteous drivers ensure a calm, professional experience—perfect for corporate guests, VIP clients, or senior travelers seeking smooth and safe airport transportation."
    },
    {
      "name": "Online Booking Innova Crysta Taxi Pune Airport",
      "description": "Book your Pune Airport Innova Crysta cab online in just a few clicks. Enjoy transparent pricing, real-time confirmations, and the convenience of multiple payment options—ideal for business travelers, family members, or visitors planning in advance."
    },
    {
      "name": "Family Innova Crysta Pune Airport Taxi",
      "description": "Travel to Pune Airport with your entire family in comfort with our spacious 6- or 7-seater Innova Crysta taxi. With generous luggage space, rear AC vents, and smooth ride quality, it's the perfect choice for family airport transfers, even with kids or elderly members onboard."
    },
    {
      "name": "Affordable Innova Crysta Airport Cab Pune",
      "description": "Looking for a premium ride without breaking your budget? Our affordable Innova Crysta airport cabs in Pune offer luxury at a fair price. Enjoy reliable pickup, clean vehicles, and courteous service without hidden charges or surge pricing."
    },
    {
      "name": "Private Innova Crysta Pune Airport Ride",
      "description": "Choose privacy and comfort with our exclusive Innova Crysta taxi rides to and from Pune Airport. No ride-sharing, no delays—just your own clean, sanitized cab for a peaceful journey tailored to your schedule and preferences."
    },
    {
      "name": "AC Innova Crysta Pune Airport Transfer",
      "description": "Beat the Pune heat and travel in air-conditioned comfort with our Innova Crysta airport transfer service. Dual-zone climate control, plush seating, and professional service make this the ideal option for arriving or departing in style and comfort."
    }
  ],
  "tableData": [
    ["Innova Crysta Taxi Pune Airport", "Pune Airport Innova Crysta Cab Booking"],
    ["Chauffeur Driven Innova Crysta Pune Airport", "Online Booking Innova Crysta Taxi Pune Airport"],
    ["Family Innova Crysta Pune Airport Taxi", "Affordable Innova Crysta Airport Cab Pune"],
    ["Private Innova Crysta Pune Airport Ride", "AC Innova Crysta Pune Airport Transfer"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Premium Innova Crysta Taxi for Pune Airport Transfers",
    "WhyChoosedescription": "Travel to or from Pune Airport in style and comfort with our Innova Crysta taxi service. Whether it’s a business trip, family vacation, or group travel, our spacious cabs ensure a smooth and timely airport transfer experience every time."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable for Travelers and Luggage",
    "WhyChoosedescription": "Innova Crysta offers generous space for up to 6–7 passengers along with large luggage capacity, making it perfect for airport pickups or drops. Enjoy plush seating, strong air-conditioning, and a smooth ride after or before your flight."
  },
  {
    "WhyChooseheading": "Punctual and Professional Chauffeurs",
    "WhyChoosedescription": "Our trained drivers track your flight status in real-time to ensure on-time pickups and drops. With deep knowledge of Pune city routes and traffic conditions, they provide reliable and courteous service around the clock."
  },
  {
    "WhyChooseheading": "Sanitized and Well-Maintained Vehicles",
    "WhyChoosedescription": "Every Innova Crysta is thoroughly cleaned and sanitized before each trip. With regular maintenance and inspection, our cabs meet the highest standards of safety and cleanliness—ideal for both solo and group travelers."
  },
  {
    "WhyChooseheading": "Available for Domestic and International Terminal Transfers",
    "WhyChoosedescription": "We offer Innova Crysta taxis for both arrivals and departures at Pune Airport, covering all major areas like Hinjewadi, Viman Nagar, Kharadi, Baner, Wakad, and more. Book anytime—day or night."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Extra Charges",
    "WhyChoosedescription": "Our airport taxi fares include tolls, driver allowances, and fuel—there are no hidden fees. Get upfront billing and enjoy a luxury ride at a fair and honest price."
  },
  {
    "WhyChooseheading": "Ideal for Families, VIP Guests, and Corporate Travel",
    "WhyChoosedescription": "Innova Crysta is a top choice for families with kids, senior citizens, corporate executives, or travelers with heavy baggage. Experience smooth and comfortable transfers to and from Pune Airport."
  },
  {
    "WhyChooseheading": "24/7 Booking and Flight Monitoring Support",
    "WhyChoosedescription": "Our customer service team is available 24/7 to assist with bookings, reschedules, or last-minute airport cab requests. We monitor your flight in real-time to adjust pickup accordingly, ensuring zero wait time."
  }
]

























    }

const faqData = [
    {
        question: "How can I book an Innova Crysta taxi for Pune Airport?",
        answer: "You can easily book by calling Meghana Cab at +91 9075462128 or through our website for quick reservations."
    },
    {
        question: "Is the Innova Crysta suitable for airport transfers?",
        answer: "Yes, the Innova Crysta provides spacious seating and ample luggage space, making it ideal for airport transfers."
    },
    {
        question: "Can I book the Innova Crysta taxi for both pickup and drop at Pune Airport?",
        answer: "Absolutely, we offer both pickup and drop services at Pune Airport."
    },
    {
        question: "Are the Innova Crysta taxis sanitized before airport trips?",
        answer: "Yes, all vehicles are thoroughly sanitized before each airport transfer for your safety."
    },
    {
        question: "How many passengers can travel comfortably in the Innova Crysta?",
        answer: "The Innova Crysta comfortably seats 6 to 7 passengers along with their luggage."
    },
    {
        question: "Is the taxi service available 24/7 for Pune Airport transfers?",
        answer: "Yes, Meghana Cab offers round-the-clock taxi services for airport transfers."
    },
    {
        question: "What is included in the Pune Airport Innova Crysta taxi fare?",
        answer: "The fare includes driver charges, fuel, and tolls. Additional waiting or parking charges may apply."
    },
    {
        question: "How do I contact Meghana Cab for Pune Airport taxi booking?",
        answer: "You can call us anytime at +91 9075462128 or book online via our website."
    },
    {
        question: "Can I request extra stops during the airport transfer?",
        answer: "Yes, additional stops can be arranged upon request during booking."
    },
    {
        question: "What payment options are available for Pune Airport taxi bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Ramesh Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The Innova Crysta taxi to Pune Airport was punctual and very comfortable. Highly recommended!”',
    },
    {
        name: 'Ms. Sneha Joshi',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent airport taxi service with Meghana Cab. The vehicle was clean and the driver courteous.”',
    },
];

























































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









const innovaPuneAirportSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Innova Crysta Pune Airport Taxi Service",
  "description": "Book chauffeur-driven Innova Crysta taxi service for Pune Airport transfers. Affordable, private, AC cabs available with easy online booking for family and business travel.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Airport Taxi Service",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/innova-crysta-pune-airport-taxi"
  }
};






    return (
        <div>


<Helmet>
  <title>Innova Crysta Pune Airport Taxi | Comfortable Airport Transfers</title>
  <meta
    name="description"
    content="Chauffeur-driven Innova Crysta taxi service for Pune Airport transfers. Affordable and private AC cabs with online booking available."
  />
  <meta
    name="keywords"
    content="Innova Crysta Taxi Pune Airport, Pune Airport Innova Crysta Cab Booking, Chauffeur Driven Innova Crysta Pune Airport, Online Booking Innova Crysta Taxi Pune Airport, Family Innova Crysta Pune Airport Taxi, Affordable Innova Crysta Airport Cab Pune, Private Innova Crysta Pune Airport Ride, AC Innova Crysta Pune Airport Transfer"
  />
  <script type="application/ld+json">
    {JSON.stringify(innovaPuneAirportSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/26.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Innovacrystapuneairport;